import type { Sticker } from '../types';

export const santa: Sticker[] = [
  {
    id: 10001,
    url: 'https://stickers.nauczniaczek.pl/colections/13373358-santa-claus/png/001-santa-claus.png',
    name: 'Święty Mikołaj',
    category: 'santa',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 10002,
    url: 'https://stickers.nauczniaczek.pl/colections/13373358-santa-claus/png/002-santa-claus.png',
    name: 'Mikołaj z Prezentami',
    category: 'santa',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 10003,
    url: 'https://stickers.nauczniaczek.pl/colections/13373358-santa-claus/png/003-santa-claus.png',
    name: 'Mikołaj z Workiem',
    category: 'santa',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 10004,
    url: 'https://stickers.nauczniaczek.pl/colections/13373358-santa-claus/png/004-santa-claus.png',
    name: 'Wesoły Mikołaj',
    category: 'santa',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 10005,
    url: 'https://stickers.nauczniaczek.pl/colections/13373358-santa-claus/png/005-santa-claus.png',
    name: 'Mikołaj z Dzwonkiem',
    category: 'santa',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 10006,
    url: 'https://stickers.nauczniaczek.pl/colections/13373358-santa-claus/png/006-santa-claus.png',
    name: 'Mikołaj z Listą',
    category: 'santa',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 10007,
    url: 'https://stickers.nauczniaczek.pl/colections/13373358-santa-claus/png/007-santa-claus.png',
    name: 'Tańczący Mikołaj',
    category: 'santa',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 10008,
    url: 'https://stickers.nauczniaczek.pl/colections/13373358-santa-claus/png/008-santa-claus.png',
    name: 'Mikołaj z Cukierkiem',
    category: 'santa',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 10009,
    url: 'https://stickers.nauczniaczek.pl/colections/13373358-santa-claus/png/009-santa-claus.png',
    name: 'Mikołaj z Gwiazdką',
    category: 'santa',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 10010,
    url: 'https://stickers.nauczniaczek.pl/colections/13373358-santa-claus/png/010-santa-claus.png',
    name: 'Mikołaj na Saniach',
    category: 'santa',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 10011,
    url: 'https://stickers.nauczniaczek.pl/colections/13373358-santa-claus/png/011-santa-claus.png',
    name: 'Mikołaj z Choinką',
    category: 'santa',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 10012,
    url: 'https://stickers.nauczniaczek.pl/colections/13373358-santa-claus/png/012-santa-claus.png',
    name: 'Mikołaj z Reniferem',
    category: 'santa',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 10013,
    url: 'https://stickers.nauczniaczek.pl/colections/13373358-santa-claus/png/013-santa-claus.png',
    name: 'Mikołaj z Lampionem',
    category: 'santa',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 10014,
    url: 'https://stickers.nauczniaczek.pl/colections/13373358-santa-claus/png/014-santa-claus.png',
    name: 'Mikołaj z Piernikiem',
    category: 'santa',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 10015,
    url: 'https://stickers.nauczniaczek.pl/colections/13373358-santa-claus/png/015-santa-claus.png',
    name: 'Mikołaj z Komina',
    category: 'santa',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 10016,
    url: 'https://stickers.nauczniaczek.pl/colections/13373358-santa-claus/png/016-santa-claus.png',
    name: 'Mikołaj z Skarpetą',
    category: 'santa',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 10017,
    url: 'https://stickers.nauczniaczek.pl/colections/13373358-santa-claus/png/017-santa-claus.png',
    name: 'Mikołaj z Bałwankiem',
    category: 'santa',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 10018,
    url: 'https://stickers.nauczniaczek.pl/colections/13373358-santa-claus/png/018-santa-claus.png',
    name: 'Mikołaj z Elfem',
    category: 'santa',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 10019,
    url: 'https://stickers.nauczniaczek.pl/colections/13373358-santa-claus/png/019-santa-claus.png',
    name: 'Mikołaj z Bombką',
    category: 'santa',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 10020,
    url: 'https://stickers.nauczniaczek.pl/colections/13373358-santa-claus/png/020-santa-claus.png',
    name: 'Mikołaj z Prezentem',
    category: 'santa',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  }
];